import { Injectable } from "@angular/core";
import { DynamicViewRequesterInfoComponentsDictionary, ViewRequesterInfoComponentItem } from '@linkdev/shared-library';
import { RequesterInfoPersonalComponent, RequesterInfoCorporateComponent } from '@linkdev/service-management-library';
import { RequesterInfoOrganizationComponent, SSAInternalComponent, RequesterInfoIndividualComponent } from "@linkdev/ssa-shared";

@Injectable()
export class DynamicViewRequesterInfoDictionary implements DynamicViewRequesterInfoComponentsDictionary {
    public getDynamicComponents(): ViewRequesterInfoComponentItem[] {
        return this._dynamicComponents;
    }

    private _dynamicComponents: ViewRequesterInfoComponentItem[] = [
        new ViewRequesterInfoComponentItem(RequesterInfoPersonalComponent, "RequesterInfoPersonalComponent"),
        new ViewRequesterInfoComponentItem(RequesterInfoCorporateComponent, "RequesterInfoCorporateComponent"),
        new ViewRequesterInfoComponentItem(RequesterInfoOrganizationComponent, "RequesterInfoOrganizationComponent"),
        new ViewRequesterInfoComponentItem(SSAInternalComponent, "SSAInternalComponent"),
        new ViewRequesterInfoComponentItem(RequesterInfoIndividualComponent, "RequesterInfoIndividualComponent"),
    ]

}